<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import Aws from "@/services/Aws";
import modalEditAutoScalingGroup from "@/components/modals/monitor/aws/modalEditAutoScalingGroup";
import modalAddNewTemplateVersion from "@/components/modals/monitor/aws/modalAddNewTemplateVersion";
import modalViewLaunchTemplateVersions from "@/components/modals/monitor/aws/modalViewLaunchTemplateVersions";
import Swal from "sweetalert2";

export default {
    components: { Layout, PageHeader, modalEditAutoScalingGroup, modalAddNewTemplateVersion, modalViewLaunchTemplateVersions },
    data() {
        return {
            title: "AWS Auto Scaling Groups",
            error: null,
            tableData: [],
            currentPage: 1,
            perPage: 10,
            items: [
                {
                    text: "AWS",
                },
                {
                    text: "AWS Auto Scaling Groups",
                    active: true,
                },
            ] ,
            pageOptions: [10, 25],
            filter: null,
            filterOn: [],
            sortBy: "AutoScalingGroupName",
            sortDesc: false,
            isBusy: false,
            autoScalingGroupData: [],
            fields: [
                {
                    key: "AutoScalingGroupName",
                    label: "Auto Scaling Group Name",
                    sortable: true,
                },
                {
                    key: "MinSize",
                    label: "Min Size",
                    sortable: false,
                    class: "text-center"
                },
                {
                    key: "MaxSize",
                    label: "Max Size",
                    sortable: false,
                    class: "text-center"
                },
                {
                    key: "DesiredCapacity",
                    label: "Desired Capacity",
                    sortable: false,
                    class: "text-center"
                },
                { key: "LaunchTemplateName", label: "Launch Template Name", sortable: false },
                { key: "LaunchTemplateId", label: "Launch Template ID", sortable: false },
                { key: "LaunchTemplateVersion", label: "Launch Template Ver.", sortable: false, class: "text-center" },
                {
                    key: "TargetGroupARNsExtendedInfo",
                    label: "TargetGroupARNs",
                    sortable: false,
                },
                "action",
            ],
            totalRows: 0,
            showModal: false,
            launchTemplateName: '',
            inServiceInstances: [],
            launchTemplateId: '',
            launchTemplateData: ''
        };
    },
    async mounted() {
        await this.getAutoScalingGroups()
    },
    methods: {
        async getAutoScalingGroups() {
            try {
                this.isBusy = true;
                const response = await Aws.getAutoScalingGroups();
                this.originalTableData = response.data.data;
                this.tableData = [...this.originalTableData];
                this.totalRows = this.tableData.length;
            } catch (error) {
                this.error = error.response.data.error ? error.response.data.error : "";
                this.tableData = [];
                this.totalRows = 0;
            } finally {
                this.showLoader = false;
                this.isBusy = false;
            }
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        editAutoscalingGroup(autoScalingGroupData){
            this.autoScalingGroupData = autoScalingGroupData
            this.$bvModal.show("edit_autoscalinggroup");
        },

        callModaladdNewTemplateVersion(launchTemplateName, launchTemplateId, instances){
            // filter instances that are InService
            this.inServiceInstances = instances.filter(inst => inst.LifecycleState === "InService");
            this.launchTemplateName = launchTemplateName
            this.launchTemplateId = launchTemplateId
            this.$bvModal.show("addNewTemplateVersion");
        },

        isNewerTemplateAvailable(launchTemplate) {
            if (!launchTemplate) return false;

            const current = parseInt(launchTemplate.ResolvedVersion || launchTemplate.Version || 0);
            const latest = parseInt(launchTemplate.LatestVersionNumber || 0);

            return latest > current;
        },

        showNewVersionDetails(launchTemplate) {
            const details = launchTemplate.LatestVersionDetails;

            if (!details) {
                Swal.fire({
                    icon: "info",
                    title: "No Details Found",
                    text: "No information available for the latest version.",
                });
                return;
            }

            const securityGroupIds = details.LaunchTemplateData && Array.isArray(details.LaunchTemplateData.SecurityGroupIds)
                ? details.LaunchTemplateData.SecurityGroupIds
                : [];
            const securityGroups = securityGroupIds.length ? securityGroupIds.join(', ') : '-';

            const html = `
        <div class="text-start">
            <p class="mt-3 mb-3"><strong>Name:</strong><br>${details.LaunchTemplateName}</p>
            <p class="mb-3"><strong>Version:</strong><br>${details.VersionNumber}</p>
            <p class="mb-3"><strong>Description:</strong><br>${details.VersionDescription || '-'}</p>
            <p class="mb-3"><strong>Created By:</strong><br>${details.CreatedBy}</p>
            <p class="mb-3"><strong>Created At:</strong><br>${details.CreateTime}</p>
            <p class="mb-3"><strong>Image ID:</strong><br>${details.LaunchTemplateData.ImageId}</p>
            <p class="mb-3"><strong>Instance Type:</strong><br>${details.LaunchTemplateData.InstanceType}</p>
            <p class="mb-3"><strong>Key Name:</strong><br>${details.LaunchTemplateData.KeyName}</p>
            <p class="mb-0"><strong>Security Groups:</strong><br>${securityGroups}</p>
        </div>
    `;

            Swal.fire({
                title: `New Launch Template v${details.VersionNumber}`,
                html: html,
                showCancelButton: true,
                cancelButtonText: "Cancel",
                confirmButtonText: "Make Default Template",
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                width: 600,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: `Make ${details.VersionNumber} the Default Launch Template?`,
                        icon: "warning",
                        html: `
                    <p>Type <strong>"Confirm"</strong> to proceed:</p>
                    <input type="text" id="confirmInput" class="swal2-input" autocomplete="off">
                `,
                        showCancelButton: true,
                        confirmButtonText: "Confirm",
                        confirmButtonColor: "#34c38f",
                        cancelButtonColor: "#f46a6a",
                        showLoaderOnConfirm: true,
                        preConfirm: () => {
                            const value = Swal.getPopup().querySelector("#confirmInput").value;
                            if (value.toLowerCase() !== "confirm") {
                                Swal.showValidationMessage('You must type "Confirm" to proceed');
                                return false;
                            }

                            return Aws.makeDefaultLaunchTemplate({
                                LaunchTemplateId: details.LaunchTemplateId,
                                VersionNumber: details.VersionNumber,
                            })
                                .then((response) => {
                                    return response;
                                })
                                .catch((error) => {
                                    let errorMsg = error.response.data.error
                                        ? error.response.data.error
                                        : "";
                                    this.failedmsg("Fail!", errorMsg);
                                });
                        },
                    }).then((res) => {
                        if (result.isConfirmed) {
                            const response = result.value; // Axios response
                            const error = response.error ? response.error : "Failed";

                            if (response === true) {
                                this.successmsg(
                                    'Default Launch Template',
                                    `Launch template ${details.VersionNumber} is now set as default.`
                                );

                                setTimeout(() => {
                                    this.getAutoScalingGroups();
                                }, 2000);
                            } else {
                                this.warningmsg("Fail!", error);
                            }
                        }
                    });
                }
            });
        },

        launchTemplateVersionsModal(launchTemplate){
          this.launchTemplateData = launchTemplate
          this.$bvModal.show("view_launchTemplateVersionsModal")
        }

    },
    middleware: "authentication",
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-3">
                                <div class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>


                            <!-- Search -->
                            <div class="col-sm-12 col-md-9">
                                <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    :busy="isBusy"
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    show-empty
                                    empty-text="No Data Found"
                                    @filtered="onFiltered"
                            >

                                <template v-slot:cell(AutoScalingGroupName)="data">
                                  <a href="#" class="text-primary" @click="editAutoscalingGroup(data.item)" title="Edit Auto Scaling Group">
                                    <span v-if="data.item.AutoScalingGroupName">
                                      {{ data.item.AutoScalingGroupName }}
                                    </span>
                                    <span v-else>N/A</span>
                                  </a>
                                </template>

                                <!-- LaunchTemplateName -->
                                <template v-slot:cell(LaunchTemplateName)="data">
                                      <span v-if="data.item.LaunchTemplate && data.item.LaunchTemplate.LaunchTemplateName">
                                        {{ data.item.LaunchTemplate.LaunchTemplateName }}
                                      </span>
                                        <span v-else>-</span>
                                </template>

                                <!-- LaunchTemplateId -->
                                <template v-slot:cell(LaunchTemplateId)="data">
                                      <span v-if="data.item.LaunchTemplate && data.item.LaunchTemplate.LaunchTemplateId">
                                        <a href="javascript:void(0);" class="px-2 text-primary" title="Copy launch Template ID" @click="copyToClipboard(data.item.LaunchTemplate.LaunchTemplateId)">
                                                <i class="uil uil-copy font-size-18"></i>
                                            </a>{{ data.item.LaunchTemplate.LaunchTemplateId }}
                                      </span>
                                      <span v-else>-</span>
                                </template>

                                <!-- LaunchTemplate ResolvedVersion -->
                                <template v-slot:cell(LaunchTemplateVersion)="data">
                                    <div class="d-inline-flex align-items-center" v-if="data.item.LaunchTemplate">
                                        <!-- Current resolved version -->
                                        <span>
                                          {{ data.item.LaunchTemplate.ResolvedVersion || data.item.LaunchTemplate.Version }}
                                        </span>
                                        <span class="mx-1" v-if="isNewerTemplateAvailable(data.item.LaunchTemplate)">/</span>
                                        <span
                                                v-if="isNewerTemplateAvailable(data.item.LaunchTemplate)"
                                                @click="showNewVersionDetails(data.item.LaunchTemplate)"
                                                class="text-dark"
                                                style="cursor: pointer;"
                                                title="Click to view latest version details"
                                        >
                                            {{ data.item.LaunchTemplate.LatestVersionNumber }}
                                        </span>
                                    </div>

                                    <span v-else>-</span>

                                    <div class="d-inline-flex align-items-center ms-2" :title="data.item.hasScheduledTemplateAction ? 'Has scheduled change template action' : 'Add New Launch Template Version'">
                                        <a
                                                href="javascript:void(0);"
                                                :class="{
                                                    'text-warning disabled': data.item.hasScheduledTemplateAction,
                                                    'text-success': !data.item.hasScheduledTemplateAction
                                                  }"
                                                @click="callModaladdNewTemplateVersion(
                                                    data.item.LaunchTemplate ? data.item.LaunchTemplate.LaunchTemplateName : '',
                                                    data.item.LaunchTemplate ? data.item.LaunchTemplate.LaunchTemplateId : '',
                                                    data.item.Instances
                                                  )"
                                        >
                                            <i class="uil uil-file-plus-alt font-size-18"></i>
                                        </a>
                                    </div>
                                </template>

                                <template v-slot:cell(TargetGroupARNsExtendedInfo)="data">
                                    <ul class="mb-0 list-unstyled">
                                        <li v-for="targetGroup in data.item.TargetGroupARNsExtendedInfo" :key="targetGroup.arn">
                                            <router-link title="View Target Group" :to="{ path: `/aws/targetgroups/${encodeURIComponent(targetGroup.arn)}` }">
                                                <span v-if="targetGroup.name">{{targetGroup.name}}</span>
                                                <span v-else><i class="uil uil-eye font-size-18"></i></span>
                                            </router-link>
                                        </li>
                                    </ul>
                                </template>

                                <template v-slot:cell(action)="data">
                                    <ul class="list-inline mb-0">
                                      <li class="list-inline-item">
                                          <a href="#" class="text-primary" @click="editAutoscalingGroup(data.item)" title="Edit Auto Scaling Group">
                                              <i class="uil uil-pen font-size-18"></i>
                                          </a>
                                      </li>
                                      <li class="list-inline-item">
                                        <a href="#" class="text-primary" @click="launchTemplateVersionsModal(data.item.LaunchTemplate)" title="View Launch Template Versions">
                                          <i class="uil uil-history font-size-18"></i>
                                        </a>
                                      </li>
                                    </ul>
                                </template>

                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modalEditAutoScalingGroup
                :autoScalingGroupData="this.autoScalingGroupData"
                @onRefresh="getAutoScalingGroups"
        ></modalEditAutoScalingGroup>

        <modalAddNewTemplateVersion
                :launchTemplateId = launchTemplateId
                :launchTemplateName = launchTemplateName
                :inServiceInstances = inServiceInstances
                @onRefresh="getAutoScalingGroups"
        ></modalAddNewTemplateVersion>

        <modalViewLaunchTemplateVersions
            :launchTemplateData="this.launchTemplateData"
            @onRefresh="getAutoScalingGroups"
        ></modalViewLaunchTemplateVersions>

    </Layout>
</template>
